var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        scrollable: "",
        "max-height": _vm.maxHeight,
        "max-width":
          _vm.$vuetify.breakpoint.name == "xs" ||
          _vm.$vuetify.breakpoint.name == "sm"
            ? "90%"
            : _vm.maxWidth,
        persistent: "",
        "retain-focus": false,
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "ma-0 pa-0" },
            [
              _c(
                "v-app-bar",
                {
                  class: _vm.color + " mb-4 elevation-1",
                  attrs: { dense: "", height: _vm.height },
                },
                [
                  _c("v-icon", { attrs: { left: "", color: "white" } }, [
                    _vm._v(_vm._s(_vm.icon)),
                  ]),
                  _c(
                    "v-toolbar-title",
                    { staticClass: "subtitle-1" },
                    [
                      _vm._t("title", function () {
                        return [_vm._v(_vm._s(_vm.title))]
                      }),
                    ],
                    2
                  ),
                  _c("v-spacer"),
                  _vm._t("tools"),
                  _c(
                    "v-tooltip",
                    {
                      attrs: { bottom: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-btn",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass: "mr-1",
                                      attrs: {
                                        icon: "",
                                        small: "",
                                        disabled: _vm.disabled || _vm.updating,
                                      },
                                      nativeOn: {
                                        click: function ($event) {
                                          _vm.dialog = false
                                        },
                                      },
                                    },
                                    "v-btn",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "red lighten-2" } },
                                    [_vm._v("mdi-close")]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [_c("span", [_vm._v("Fechar")])]
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _vm.dialog
            ? _c("v-card-text", { staticClass: "pt-0" }, [_vm._t("form")], 2)
            : _vm._e(),
          _vm.actions
            ? _c(
                "v-card-actions",
                [
                  _vm.showRequiredFields
                    ? _c("small", [_vm._v("*Campos obrigatórios")])
                    : _vm._e(),
                  _vm.footerText
                    ? _c("small", [_vm._v(" " + _vm._s(_vm.footerText) + " ")])
                    : _c("small", [_vm._t("footer")], 2),
                  _c("v-spacer"),
                  _vm._t("actions"),
                  _vm.showButton
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            loading: _vm.updating,
                            disabled: _vm.disabled || _vm.disabledSave,
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                              return _vm.save()
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.textButtonSave
                                ? _vm.textButtonSave
                                : _vm.edit
                                ? "Atualizar"
                                : "Cadastrar"
                            ) + " "
                          ),
                          _c("v-icon", { attrs: { right: "", dark: "" } }, [
                            _vm._v(_vm._s(_vm.iconButtonSave)),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }